import { stores } from '../stores';
import { api } from '../api';
// import { FOREIGN_API } from '../api/constants';

export const setServerApiBaseUrl = ctx => {
  const isServer = !!ctx.req;
  if (isServer) {
    // api.defaults.baseURL = `${FOREIGN_API}/v2`; // TODO: store as global variable
  }
};

const getInitialCookieVerification = ctx => {
  const isServer = !!ctx.req;
  setServerApiBaseUrl(ctx);
  if (isServer) {
    const cookie = ctx.req.cookies && ctx.req.cookies['ring-session'];
    api.defaults.headers.common['cookie'] = `ring-session=${encodeURIComponent(
      cookie,
    )};`;
  }
  return stores.loginStore.instance.verifyCookie();
};

export default getInitialCookieVerification;
